import {
  writable
} from 'svelte/store'

export const tasks = writable([])
//
export const lang = writable('fr')

export const conversion = writable({
  en: {
    chatMessages: {
      message1: "Le chat est vide",
      message2: "être le premier à envoyer un message"
    },
    backDashboard: {
      back: 'Back to Dashboard',
      TaskbackRoute: 'Back to my tasks',
      title: {
        task: "My Tasks",
        onetask: "My Task"
      }
    },
    transaction: {
      title: 'Transaction History',
      transactiontype: {
        adjustment: "Adjustment:",
        purchase: "Purchase:",
        deducted: "Deducted:"
      },
      menu: {
        1: 'date',
        2: 'Description',
        3: 'Amount / Transaction',
        4: 'Balance',
        5: 'Transaction ID'
      }
    },
    landing: {
      stats: {
        stat1: {
          title: 'Hours',
          description: 'Number of development hours used during this month'
        },
        stat2: {
          hours: 'Hours',
          description: 'Remaining number of hours',
          minutes: 'Minutes'
        },
        stat3: {
          title: 'Tasks',
          description: 'Tasks in progress'
        }
      },

      descriptionSection: {
        title: "Thanks for your submission! Sit tight, we're assesssing your task",
        subTitle: "You'll hear back from us soon. In the meantime, please consider purchasing credits or subscribe, in order to speed up the delivery process",
        button: 'Pricing'
      },
      pricing: {
        label: 'OUR PRICING',
        title: "Choose the plan that's right for your business",
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Modi saepe sed quam. Tenetur non modi placeat neque cum voluptatibus. Officia atque',
        packages: {
          package1: {
            title: 'Started Plan',
            quantity: 'Hours',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi odit non vitae veniam voluptas at nemo',
            button: 'Get started'
          },
          package2: {
            title: 'Premium',
            quantity: 'Hours',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi odit non vitae veniam voluptas at nemo',
            button: 'Get started'
          },
          package3: {
            title: 'Platinum',
            quantity: 'Hours',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi odit non vitae veniam voluptas at nemo',
            button: 'Get started'
          }
        }
      }
    },
    accountSettings: {
      backToDashBoardTitle: 'Settings',
      generalTitle: 'General Informations',
      accountInformations: {
        generalTitle: 'Account Informations',
        labelFirstName: 'First name',
        labelLastName: 'Last name',
        labelEmail: 'Email',
        labelPhoneNumber: 'Phone Number',
        button: 'Save changes',
        language: 'language',
      },
      errors: {
        wrongPassword: "Wrong current password",
        shortPassword: "Password should be longer than 7 characters"
      },
      updated: "Password updated successfully",
      notification: {
        generalTitle: 'Manage Notifications',
        notifType: {
          email: 'Email',
          push: 'Notification Push'
        },
        options: {
          option1: {
            title: 'Issue Activity',
            subtitle: 'Send me email notification for issue activity'
          },
          option2: {
            title: 'Tracking Activity',
            subtitle: 'Send me notifications when someone has'
          },
          option3: {
            title: 'New Comments',
            subtitle: 'Send me email notification for new comments'
          }
        },
        checkBox: "Don't send me notifications after 9:00PM",
        button: 'Save changes'
      },
      password: {
        generalTitle: 'Password',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.Voluptatibus vero, repellat fugit odio reiciendis dolorum liberolaboriosam perspiciatis excepturi',
        currentPassword: 'Current password',
        newPassword: 'New password',
        confirmPassword: 'Confirm password',
        button: 'Save changes'
      }
    },
    tasks: {
      backToDashBoardTitle: 'My Tasks',
      FullTaskView: {},
      MinimizedTasksView: {
        waitingApproval: "Waiting for your approval"
      }
    },
    notifications: {
      backToDashBoardTitle: 'Notifications',
      generalTitle: 'All notifications',
      filters: {
        all: 'All notifications',
        comment: 'New messages',
        status: 'Status change',
        package: 'New package Purchase'
      },
      status: {
        1: 'Updated the status of',
        2: 'to'
      },
      comment: {
        1: 'sent you a comment in',
        2: 'task'
      },
      assigneeAdd: {
        1: 'assigned',
        2: 'to',
        3: 'task'
      },
      assigneeRemove: {
        1: 'removed the assignee',
        2: 'from',
        3: 'task'
      },
      addBalance: {
        0: "You",
        1: 'have purchased ',
        2: 'transaction history'
      }
    },
    SingleTask: {
      title: 'My task',
      TaskDescription: {
        1: 'Task ID',
        2: 'Description',
        3: 'Client',
        4: 'Assignees',
        5: 'Priority',
        6: 'Status',
        7: 'Deadline',
        8: 'Attachments',
        9: 'Task Name'
      },
      TaskComments: {
        placeholder: 'Type your message here ...'
      }
    },
    MyTasks: {
      title: 'My tasks',
      headings: {
        1: 'Boards',
        2: 'List',
        3: 'Archived'
      },
      noTasksmsg: 'You have no active tasks. Pick a task from the queue or..',
      ctaButton: 'Submit a new task',
      SubTitles: {
        1: 'Submitted',
        2: 'In Dev',
        3: 'To confirm',
        4: 'Done',
        5: 'Declined'
      },
      comment: 'Comments'
    },
    SigninPage: {
      1: 'Sign in to Expertify Tasks',
      2: 'Don\'t have an account ?',
      3: 'Sign up here',
      4: 'Forgot Password ?',
      5: 'Sign in'
    },
    SignUpPage: {
      1: 'Sign up to Expertify Tasks',
      2: 'First Name',
      3: 'Last Name',
      4: 'Password',
      5: 'Confirm Password',
      6: 'Phone Number',
      7: 'Shop name',
      8: 'Already have an account ?',
      9: 'Sing in here ?',
      10: 'Sign up'
    },
    CreateTask: {
      1: 'Submit a new task',
      2: 'Task title',
      3: 'Add the task title',
      4: 'Task details',
      5: 'Add some description of your task',
      6: 'Priority',
      7: {
        1: 'Urgent',
        2: 'High',
        3: 'Normal'
      },
      8: {
        1: 'Attachments',
        2: 'Upload files here',
        3: 'Drag and drop, or  click to select'
      },
      9: 'Send'
    },
    taskDecline: {
      1: 'Please help us to understand why you refuse to go forward and join us, so that we can improve the experience for you next time.',
      2: 'Why do you refuse ?',
      3: 'Not the right solution',
      4: 'Budget too high',
      5: 'I need more information',
      6: 'Other',
      7: 'Cancel',
      8: 'Confirm',
      9: 'Please describe to us the reason that drives you to refuse to join us...'
    },
    taskApproval: {
      1: 'If you approve it now',
      2: 'it will be delivered betwen',
      3: 'and',
      4: 'Read more',
      5: 'Current number of hours',
      6: 'New price',
      7: 'Between',
      8: 'And',
      9: 'Depends on the actual time spent ',
      10: 'Launch the task',
      11: 'Cancel'
    },
    ApproveComponent: {
      1: 'We are ready to work !',
      2: 'We commit complete this job for',
      3: 'If you approve it now,',
      4: 'and',
      5: 'Created',
      6: 'to',
      7: 'it will be delivered between',
      8: 'Yes, Continue',
      9: 'No thanks',
      10: 'Task ',
      11: 'Read more',
      12: 'Read less'
    },
    navbar: {
      1: 'Dashboard',
      2: 'My tasks',
      3: 'Transaction History',
      4: 'Notifications',
      5: 'Create task',
      6: 'Account',
      7: 'Transaction',
      8: 'Logout'
    }
  },

  fr: {
    chatMessages: {
      message1: "Le chat est vide",
      message2: "être le premier à envoyer un message"
    },
    backDashboard: {
      back: 'Retour au tableau de bord',
      TaskbackRoute: 'Retour au tableau des taches',
      title: {
        task: "Mes taches",
        onetask: "Ma tache"
      }
    },
    transaction: {
      title: 'Historique des transactions',
      transactiontype: {
        adjustment: "Ajustement:",
        purchase: "Acheter:",
        deducted: "Déduit:"
      },
      menu: {
        1: 'Date',
        2: 'Description',
        3: 'Montant / Transaction',
        4: 'Balance',
        5: 'ID de la Transaction '
      }
    },
    landing: {
      stats: {
        stat1: {
          title: 'Heures',
          description: 'Nombre utilisé ce mois pour le dévélopment'
        },
        stat2: {
          hour: 'Heures',
          description: "Nombre d'heures restantes",
          minutes: 'Minutes'
        },
        stat3: {
          title: 'Tâches',
          description: 'Tâches en cours'
        }
      },

      descriptionSection: {
        title: 'Merci pour votre soumission ! Asseyez-vous bien, nous évaluons votre tâche',
        subTitle: "Vous aurez bientôt de nos nouvelles. En attendant, pensez à acheter des crédits ou à vous abonner, afin d'accélérer le processus de livraison",
        button: 'Prix'
      },
      pricing: {
        label: 'NOS TARIFS',
        title: 'Choisissez le plan qui convient à votre entreprise',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Modi saepe sed quam. Tenetur non modi placeat neque cum voluptatibus. Officia atque',
        packages: {
          package1: {
            title: 'Started Plan',
            quantity: 'Heures',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi odit non vitae veniam voluptas at nemo,',
            button: 'Commencer'
          },
          package2: {
            title: 'Premium',
            quantity: 'Heures',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi odit non vitae veniam voluptas at nemo,',
            button: 'Commencer'
          },
          package3: {
            title: 'Platinum',
            quantity: 'Heures',
            description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Commodi odit non vitae veniam voluptas at nemo,',
            button: 'Commencer'
          }
        }
      }
    },
    accountSettings: {
      backToDashBoardTitle: 'Paramètres',
      generalTitle: 'Informations Générales',
      accountInformations: {
        generalTitle: 'Informations sur le compte',
        labelFirstName: 'Prénom',
        labelLastName: 'Nom',
        labelEmail: 'Email',
        labelPhoneNumber: 'Numéro de téléphone',
        button: 'Sauvegarder les modifications',
        language: 'language',
      },
      errors: {
        wrongPassword: "Mot de passe actuel erroné ",
        shortPassword: "Le mot de passe doit comporter plus de 7 caractères "
      },
      updated: "Mot de passe mis à jour avec succès",
      notification: {
        generalTitle: 'Gérer les notifications',
        notifType: {
          email: 'Email',
          push: 'Notification Push'
        },
        options: {
          option1: {
            title: 'Émettre une activité',
            subtitle: "Envoyez-moi une notification par e-mail pour l'activité émise"
          },
          option2: {
            title: "Suivi de l'activité",
            subtitle: "Envoyez-moi des notifications lorsque quelqu'un a"
          },
          option3: {
            title: 'Nouveaux commentaires',
            subtitle: 'Envoyez-moi une notification par e-mail pour les nouveaux commentaires'
          }
        },
        checkBox: "Ne pas m'envoyer de notifications après 21h00",
        button: 'Sauvegarder les modifications'
      },
      password: {
        generalTitle: 'Mot de passe',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.Voluptatibus vero, repellat fugit odio reiciendis dolorum liberolaboriosam perspiciatis excepturi',
        currentPassword: 'Mot de passe actuel',
        newPassword: 'Nouveau mot de passe',
        confirmPassword: 'Confirmez le mot de passe',
        button: 'Sauvegarder les modifications'
      }
    },
    notifications: {
      backToDashBoardTitle: 'Notifications',
      generalTitle: 'Toutes les notifications',
      filters: {
        all: 'Toutes les notifications',
        comment: 'Nouveaux messages',
        status: 'Changement de statut',
        package: 'Nouveau forfait Achat'
      },
      status: {
        1: 'a mis à jour le statut de',
        2: 'vers'
      },
      comment: {
        1: 'vous a envoyé un commentaire dans',
        2: 'la tâche'
      },
      assigneeAdd: {
        1: 'a attribué',
        2: 'à',
        3: 'la tâche'
      },
      assigneeRemove: {
        1: 'a retiré le cessionnaire',
        2: 'de',
        3: 'la tâche'
      },
      addBalance: {
        0: 'Vous',
        1: 'avez acheté',
        2: 'Historique des transactions'
      }
    },
    SingleTask: {
      title: 'Ma tâche',
      TaskDescription: {
        1: 'ID de la tâche',
        2: 'Description',
        3: 'Client',
        4: 'Cessionnaires',
        5: 'Priorité',
        6: 'Statut',
        7: 'Date limite',
        8: 'Pièces jointes',
        9: 'Nom de la tâche'
      },
      TaskComments: {
        placeholder: 'Tapez votre message ici ...'
      }
    },
    tasks: {
      backToDashBoardTitle: 'Mes tâches',
      FullTaskView: {},
      MinimizedTasksView: {
        waitingApproval: "En attente de votre accord"
      }
    },
    MyTasks: {
      title: 'Mes tâches',
      headings: {
        1: 'Tableau',
        2: 'Liste',
        3: 'Archivé'
      },
      noTasksmsg: 'Vous n\'avez aucune tâche active. Choisissez une tâche dans la file d\'attente ou... ',
      ctaButton: 'Ajouter une nouvelle tâche ',
      SubTitles: {
        1: 'Soumis',
        2: 'En développement',
        3: 'A valider ',
        4: 'Terminé',
        5: 'Réfusé'
      },
      comment: 'Commentaires'
    },
    SigninPage: {
      1: 'Se connecter à Expertify Tasks',
      2: 'Vous n\'avez pas un compte ?',
      3: 'Inscrivez-vous ici',
      4: 'Mot de passe oublié ?',
      5: 'Se connecter'
    },
    SignUpPage: {
      1: 'Inscrivez-vous à Expertify Tasks',
      2: 'Prénom',
      3: 'Nom',
      4: 'Mot de passe',
      5: 'Confirmez votre mot de passe',
      6: 'Téléphone',
      7: 'Nom de la boutique',
      8: 'Vous avez déjà un compte ?',
      9: 'Se connecter ici',
      10: 'S\'inscrire'
    },
    CreateTask: {
      1: 'Ajouter une nouvelle tâche ',
      2: 'Titre de la tâche',
      3: 'Ajouter le titre de la tâche',
      4: 'Détails de la tâche',
      5: 'Ajoutez une description de votre tâche',
      6: 'Priorité',
      7: {
        1: 'Urgent',
        2: 'Important',
        3: 'Normale'
      },
      8: {
        1: 'Pièces jointes',
        2: 'Téléchargez des fichiers ici',
        3: 'Glissez-déposez ou cliquez pour sélectionner'
      },
      9: 'Envoyer'
    },
    taskDecline: {
      1: 'S\'il vous plaît, aidez-nous à comprendre pourquoi vous refusez de continuer et de nous rejoindre, afin que nous puissions améliorer l\'expérience pour vous la prochaine fois ',
      2: 'Pourquoi refusez-vous ?',
      3: 'Pas la bonne solution',
      4: 'Budget trop élevé',
      5: 'j\'ai besoin de plus d\'informations',
      6: 'Autre',
      7: 'Annuler',
      8: 'Confirmer',
      9: 'Veuillez nous décrire la raison qui vous pousse à refuser de nous rejoindre...'
    },
    taskApproval: {
      1: 'Si vous l\'approuvez maintenant',
      2: 'elle sera livré entre',
      3: 'Et',
      4: 'Lire la suite',
      5: 'Nombre d\'heures actuel',
      6: 'Nouveau solde',
      7: 'Entre',
      8: 'Et',
      9: 'Dépend du temps réel passé ',
      10: 'Lancer la tâche ',
      11: 'Annuler'
    },
    ApproveComponent: {
      1: 'Nous sommes prêts à travailler !',
      2: 'Nous nous engageons à terminer ce travail pour',
      3: 'Si vous l\'approuvez maintenant,',
      4: 'et',
      5: 'Créé',
      6: 'à',
      7: 'elle sera livré entre',
      8: 'Oui, Continue',
      9: 'Non merci',
      10: 'Tâche ',
      11: 'Lire la suite',
      12: 'lire moins'
    },
    navbar: {
      1: 'Tableau de bord ',
      2: 'Mes tâches',
      3: 'Historique des transactions',
      4: 'Notifications',
      5: 'Ajouter une tâche',
      6: 'Compte',
      7: 'Transaction',
      8: 'Se déconnecter'
    }
  }
})